import React, { useEffect, useState } from "react";
import { HowItWork } from "../components/home/how-it-work";
import FeaturedProperties from "../components/home/featured-properties";
import DownloadApp from "../components/home/download-app";
import Testimonials from "../components/home/testimonials";
import FaqSection from "../components/home/faq-section";
import HomeBlogs from "../components/home/home-blogs";
import { Helmet } from "react-helmet-async";
import aboutImage from "../assets/images/why-choose-us.png";
import ownerCta from "../assets/images/owner-cta.png";
import ownerCta1 from "../assets/images/owner-cta-1.png";
import HSRLayout from "../assets/images/areas/hsr.png";
import BTMLayout from "../assets/images/btm-layout.png";
import ElectronicCity from "../assets/images/areas/electronic-city.png";
import Whitefield from "../assets/images/areas/whitefield.png";
import Koramangala from "../assets/images/koramangala.png";
import Marathahalli from "../assets/images/areas/marathahali.png";
import Mahadevpura from "../assets/images/areas/mahadevpura.png";
import SarjapurRoad from "../assets/images/areas/sarjapura.png";
import { Link } from "react-router-dom";
import Banner from "../components/home/banner";
import NewlyArrivedProperties from "../components/home/newly-arrived-property";
import FastSellingProperties from "../components/home/fast-selling-properties";
import buyImg1 from "../assets/images/areas/sarjapura.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faHeart,
  faLocationDot,
  faMobileScreenButton,
} from "@fortawesome/free-solid-svg-icons";
import BuyPropertyCard from "../components/common/buy-property-card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import bgCircle from "../assets/images/icons/blue-circle.svg";
import googleplay from "../assets/images/googleplay.png";
import appImg from "../assets/images/app.png";
import appQr from "../assets/images/app-qr.jpg";
import downloadAppImg from "../assets/images/download-app.png";
import buymoduleService from "../services/BuyModule-service/buy-module-service";
import { logDOM } from "@testing-library/react";
import { ErrorHandlingDesign } from "../components/common/errorHandlingDesign";
import { ProgressSpinner } from "primereact/progressspinner";
import { handleErrors } from "../utils/errorHandler";
import { Col } from "react-bootstrap";
import BuyPropertyCardSkeleton from "../components/common/buy-property-card-skeliton";
import WhyChooseSection from "../components/common/WhyChooseSection";
import ReflectionsPromoBanner from "../components/home/reflections-promo-banner";
const BuyPage = () => {
  const locations = [
    {
      name: "HSR Layout",
      thumbImage: HSRLayout,
      link: "hsr-layout",
      hoverContent:
        "Affordable 1BHK & 2BHK flats for rent in HSR Layout – Find your perfect apartment with werentt.",
    },
    {
      name: "BTM Layout",
      thumbImage: BTMLayout,
      link: "btm-layout",
      hoverContent:
        "Find your perfect home near everything you love in BTM Layout with werentt.",
    },
    {
      name: "Electronic City",
      thumbImage: ElectronicCity,
      link: "electronic-city",
      hoverContent:
        "Rent 1BHK and 2BHK apartments in Electronic City – Prime location flats available!",
    },
    {
      name: "Whitefield",
      thumbImage: Whitefield,
      link: "whitefield",
      hoverContent:
        "Spacious 1BHK and 2BHK flats for rent in Whitefield – Premium apartments listed by werentt.",
    },
    {
      name: "Koramangala",
      thumbImage: Koramangala,
      link: "koramangala",
      hoverContent:
        "Style, social life, and serenity—get it all in Koramangala with werentt rentals. Book your ideal apartment today.",
    },
    {
      name: "Marathahalli",
      thumbImage: Marathahalli,
      link: "marathahalli",
      hoverContent:
        "Seamless city access and cozy living with rentals in Marathahalli by werentt.",
    },
    {
      name: "Mahadevpura",
      thumbImage: Mahadevpura,
      link: "mahadevpura",
      hoverContent:
        "Find budget-friendly 1BHK & 2BHK flats for rent in Mahadevpura – Available now on werentt.",
    },
    {
      name: "Sarjapur Road",
      thumbImage: SarjapurRoad,
      link: "sarjapur-road",
      hoverContent:
        "Premium 1BHK & 2BHK apartments for rent on Sarjapur Road – Browse our listings today.",
    },
  ];

  // this state is used to store the data recieved for New Arrived properties
  const [newProperties, setNewProperties] = useState([]);
  const [recommendedProperties, setRecommendedProperties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // here we are calling the api
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const [newArrivedRes, recommendedRes] = await Promise.all([
          buymoduleService.newProperties(),
          buymoduleService.recomendedProperties(),
        ]);

        setNewProperties(newArrivedRes.data.result || []);
        setRecommendedProperties(recommendedRes.data.result || []);

        // console.log("New Arrived:", newArrivedRes.data.result);
        // console.log("Recommended:", recommendedRes.data.result);
      } catch (err) {
        setError(handleErrors(err));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // here we are checking for  mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 577);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Werentt - Rent Houses, Flats and Apartments in Bangalore</title>
        <meta
          name="description"
          content="Planning to rent a house in Bangalore? Rent 1BHK, 2BHK- semi furnished or full furnished flats or apartments from Werentt today! Contact to know more."
        />
        <meta
          name="keywords"
          content="rental properties in Bangalore, apartments for rent in Bangalore, villas for rent in Bangalore, rental homes in Bangalore, WeRentt, houses for rent in Bangalore, Flats for rent in Bangalore, property listings in Bangalore, Houses for lease in Bangalore, Apartments for lease in Bangalore, Flats for lease in Bangalore, affordable rentals in Bangalore, rental marketplace in Bangalore"
        />
      </Helmet>

      <div className="main-wrapper">
        <Banner
          classname="buy-banner"
          heading=" Properties for Sale in Bangalore Buy Direct, Zero Brokerage"
          subheading="Explore verified 1BHK, 2BHK & 3BHK flats and apartments for sale across Bangalore."
        />
        <ReflectionsPromoBanner />
        <section className="buy-property feature-property-sec">
          <div className="container">
            <div className="buy-home d-flex justify-content-between flex-sm-row">
              <div className="section-heading align-items-start">
                <h2>Explore Properties for Sale in Bangalore</h2>
                {/* <p>Choose your preferred choice of Properties in Bangalore</p> */}
              </div>
              <div className="ViewAllButton d-flex justify-content-center align-items-start pt-2">
                <Link to="/buy/list">
                  <span className="btn btn-primary">View more ›</span>
                </Link>
              </div>
            </div>
            <div className="row row-gap-gutter">
              {error ? (
                <ErrorHandlingDesign errorMessage={error} />
              ) : loading ? (
                // <ProgressSpinner
                //   style={{ width: "50px", height: "50px" }}
                //   strokeWidth="3"
                //   fill="var(--surface-ground)"
                //   animationDuration=".5s"
                // />
                !isMobile ? (
                  <div className="row w-100">
                    {[1, 2, 3, 4].map((item) => (
                      <div className="col-3" key={item}>
                        <BuyPropertyCardSkeleton />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="row w-100">
                    {[1].map((item) => (
                      <div className="col-12" key={item}>
                        <BuyPropertyCardSkeleton />
                      </div>
                    ))}
                  </div>
                )
              ) : isMobile ? (
                <Col className="feature-slider">
                  <Swiper
                    slidesPerView={1.3}
                    modules={[Pagination]}
                    spaceBetween={24}
                    pagination={{
                      clickable: true,
                    }}
                  >
                    {newProperties.map((property) => (
                      <SwiperSlide key={property.id}>
                        <BuyPropertyCard
                          property={{
                            ...property,
                            gallery: property.gallery.filter(
                              (media) => media.fileType !== "Video",
                            ),
                          }}
                          flatId={property.id}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              ) : (
                newProperties.map((property) => (
                  <div className="col-12 col-md-6 col-lg-3">
                    <BuyPropertyCard
                      property={{
                        ...property,
                        gallery: property.gallery.filter(
                          (media) => media.fileType !== "Video",
                        ),
                      }}
                      flatId={property.id}
                    />
                  </div>
                ))
              )}
            </div>
          </div>
        </section>
        <section className="werentt-assist">
          <div className="container">
            <div className="section-heading align-items-start">
              <h2>WeRentt Assist </h2>
              <p>
                Simplify your property journey with our trusted buyer/seller
                services
              </p>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-3">
                <div className="werentt-assist-card">
                  <div className="icon">
                    <img src="/werentt-assist-1.png" alt="assist" />
                  </div>
                  <div className="card-content">
                    <div className="title">
                      <h3 className="text-black">Home Loans Simplified</h3>
                      <p>
                        Get the best offers from top banks with minimal
                        documentation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <div className="werentt-assist-card">
                  <div className="icon">
                    <img src="/werentt-assist-2.png" alt="assist" />
                  </div>
                  <div className="card-content">
                    <div className="title">
                      <h3 className="text-black">Property Verification</h3>
                      <p>
                        Legal and technical due diligence for peace of mind
                        before purchase.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <div className="werentt-assist-card h-100">
                  <div className="icon">
                    <img src="/werentt-assist-3.png" alt="assist" />
                  </div>
                  <div className="card-content">
                    <div className="title">
                      <h3 className="text-black">Fixed fee model</h3>
                      <p>
                        {/* Direct transactions with verified sellers and builders. */}
                        Free from brokerage hassle
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <div className="werentt-assist-card h-100">
                  <div className="icon">
                    <img src="/werentt-assist-4.png" alt="assist" />
                  </div>
                  <div className="card-content">
                    <div className="title">
                      <h3 className="text-black">Move-in Support</h3>
                      <p>Seamless relocation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="located-in">
          <div className="container">
            <div className="row location-card-row">
              <div className="col-12">
                <div className="section-heading align-items-start mb-0">
                  <h2>
                    {" "}
                    {/* Popular Localities in Bangalore for Buying Houses and Flats */}
                    Preferred residential areas in Bangalore for Buying or
                    Investing
                  </h2>
                  {/* <p>Find your tribe, live your life</p> */}
                </div>
              </div>
              {locations?.map((location, index) => (
                <div className="col-6 col-sm-6 col-md-4 col-lg-3">
                  <Link
                    className="located-in-card"
                    to={`list?search=${location.link}`}
                  >
                    <div className="located-in-thumb">
                      <img src={location.thumbImage} alt={location?.name} />
                      <div className="hover-content">
                        <p>{location.hoverContent}</p>
                      </div>
                    </div>
                    <h3>{location.name}</h3>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="prominent-projects buy-model">
          <div className="container">
            <div className="section-heading align-items-start">
              <h2>Prominent projects to explore</h2>
              {/* <p>Best projects to look out for</p> */}
            </div>
            <div className="prominent-slider-wrapper">
              <Swiper
                slidesPerView={1.2}
                spaceBetween={24}
                pagination={{
                  clickable: true,
                }}
                navigation={{
                  nextEl: ".custom-next",
                  prevEl: ".custom-prev",
                }}
                modules={[Navigation]}
                breakpoints={{
                  576: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                  },
                  991: {
                    slidesPerView: 2.5,
                    spaceBetween: 16,
                  },
                  1200: {
                    slidesPerView: 2.8,
                    spaceBetween: 24,
                  },
                }}
              >
                <SwiperSlide>
                  <div className="prominent-project-card">
                    <div className="project-image">
                      <img src="/prominant-property-1.png" alt="property" />
                    </div>
                    <div className="project-details">
                      <h3>Brigade Exotica</h3>
                      <p>Whitefield, Bangalore</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="prominent-project-card">
                    <div className="project-image">
                      <img src="../building-1.jpg" alt="building" />
                    </div>
                    <div className="project-details">
                      <h3>Prestige Sky Gardens</h3>
                      <p>Sarjapur Road, Bangalore</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="prominent-project-card">
                    <div className="project-image">
                      <img src="../building-2.jpg" alt="building" />
                    </div>
                    <div className="project-details">
                      <h3>Sobha Green Heights</h3>
                      <p>Hinjewadi, Pune</p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div className="swiper-button-wrap">
                <div className="swiper-button-prev custom-prev"></div>
                <div className="swiper-button-next custom-next"></div>
              </div>
            </div>
          </div>
        </section>
        <section className="buy-property feature-property-sec">
          <div className="container">
            <div className="buy-home d-flex justify-content-between flex-sm-row">
              <div className="section-heading align-items-start">
                <h2>Recommended Properties for You </h2>
                {/* <p>Choose your preferred choice of Properties in Bangalore</p> */}
              </div>
              <div className="ViewAllButton d-flex justify-content-center align-items-start pt-2">
                <Link to="/buy/list">
                  <span className="btn btn-primary">View more ›</span>
                </Link>
              </div>
            </div>
            <div className="row row-gap-gutter">
              {error ? (
                <ErrorHandlingDesign errorMessage={error} />
              ) : loading ? (
                // <ProgressSpinner
                //   style={{ width: "50px", height: "50px" }}
                //   strokeWidth="3"
                //   fill="var(--surface-ground)"
                //   animationDuration=".5s"
                // />
                !isMobile ? (
                  <div className="row w-100">
                    {[1, 2, 3, 4].map((item) => (
                      <div className="col-3" key={item}>
                        <BuyPropertyCardSkeleton />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="row w-100">
                    {[1].map((item) => (
                      <div className="col-12" key={item}>
                        <BuyPropertyCardSkeleton />
                      </div>
                    ))}
                  </div>
                )
              ) : isMobile ? (
                <Col className="feature-slider">
                  <Swiper
                    slidesPerView={1.3}
                    modules={[Pagination]}
                    spaceBetween={24}
                    pagination={{
                      clickable: true,
                    }}
                  >
                    {recommendedProperties.map((property) => (
                      <SwiperSlide key={property.id}>
                        <BuyPropertyCard
                          property={{
                            ...property,
                            gallery: property.gallery.filter(
                              (media) => media.fileType !== "Video",
                            ),
                          }}
                          flatId={property.id}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              ) : (
                recommendedProperties.map((property) => (
                  <div className="col-12 col-md-6 col-lg-3">
                    <BuyPropertyCard
                      property={{
                        ...property,
                        gallery: property.gallery.filter(
                          (media) => media.fileType !== "Video",
                        ),
                      }}
                      flatId={property.id}
                    />
                  </div>
                ))
              )}
            </div>
          </div>
        </section>

        <WhyChooseSection />

        <section className="buy-download-cta">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12 col-xl-12">
                <div
                  className="easy-stay-card"
                  style={{
                    background: "linear-gradient(45deg, #080039, #000B29)",
                  }}
                >
                  <div className="row">
                    <div className="col-12 col-md-7">
                      <div className="d-flex buy-model-app-download">
                        <div className="buy-qr-code">
                          <div className="app-qr">
                            <img src={appQr} alt="app" />
                          </div>
                        </div>
                        <div className="download-buy-app-content pl-lg-3">
                          <h2 className="text-white">
                            Download the WeRentt App Today!{" "}
                          </h2>
                          {/* <p className="mb-0 text-white">
                            Rent. Buy. Sell. All in one place.
                          </p>
                          <p className="text-white">
                           Fully furnished homes with complete maintenance.
                            Quick onboarding with digital rental agreements
                          </p> */}
                          <ul className="content-list mt-2 mb-4 text-white buy-module-mobile">
                            <li>
                              <FontAwesomeIcon
                                icon={faCheckCircle}
                                className="text-pink"
                              />
                              <span>Rent. Buy. Sell. All in one place.</span>
                            </li>
                            <li>
                              <FontAwesomeIcon icon={faCheckCircle} />
                              <span>
                                Fully furnished homes with complete
                                maintenance.{" "}
                              </span>
                            </li>
                            <li>
                              <FontAwesomeIcon icon={faCheckCircle} />
                              <span>
                                Quick onboarding with digital rental agreements
                              </span>
                            </li>
                          </ul>
                          <div className="">
                            <div className="app-info-wrap">
                              <ul>
                                <li>
                                  <Link to="https://play.google.com/store/apps/details?id=com.app.sowerent">
                                    <img src={googleplay} alt="google" />
                                  </Link>
                                </li>
                                <li>
                                  <Link to="">
                                    <img src={appImg} alt="app" />
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-5 position-unset buy-prop-download-img">
                      <div className="image">
                        <img src="/download-app.png" alt="download" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-imgs">
            <img src={bgCircle} className="bg-08" alt="circle" />
          </div>
        </section>
        <FaqSection
          type="buyModuleFaq"
          heading="FAQs – Fixed Fee Property Services"
          subText="Start Saving on Your Property Sale Today and Get Started with Transparent Fixed Fees"
        />
        <HomeBlogs sectionTitle="News & Events" />
        {/* <SocialMedia /> */}
      </div>
      {/* <div className="progress-wrap active-progress">
        <svg className="progress-circle svg-content" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div> */}
    </>
  );
};

export default BuyPage;
